<template lang="pug">
    layout.contentTransparent

        // Main title
        title-component(
            type="h2"
            slot="title"
            :title="$t('mindfulMinutes.view.title')"
        )

        div.pb-3
            v-layout(raw wrap)
                v-flex.mt-3(xs12)
                    div.mindfulMinute(v-if="session.id")

                        div.mindfulMinuteImage(:style="{ backgroundImage: `url('${session.poster}')` }")
                            div.imageAuthor(v-if="session.description" ) {{ session.description }}

                        div.mindfulMinuteText
                            div.textWrapper
                                span {{ session.title }}

                                like-component(:session="session")

            v-layout.themeGrid(row wrap)
                v-flex.mt-4(xs12)
                    title-component.sessionsTitle(type="h4" title="Our most popular themes")

                v-flex(xs6 md6 lg3 v-for="(item, key) in $t('themes.themes')" :key="`wrapper-theme-${key}`")
                    div.my-2

                        // Theme card
                        theme(
                            :key="`theme-${key}`"
                            :title="item.title"
                            :image="item.image"
                            :theme="item.theme"
                            :status="item.status"
                            :disabled="item.disabled"
                            :muted="item.muted"
                            :duration="item.duration"
                            :imageAlt="item.imageAlt"
                        )

            sessions-list-component(v-if="theme" title="Recommended videos" :session="{theme, id: ''}")

            div.bottomSpacer

</template>

<script>
    import Layout from '../../Layout/Layout';
    import Theme from '~components/Theme';
    import Title from '~components/Title';
    import SessionsList from '~components/SessionsList';
    import VueTypes from 'vue-types';
    import { mapActions, mapGetters } from 'vuex';
    import i18n from '~/i18n';
    import LikeMindfulMoment from '~components/LikeMindfulMoment';

    export default {
        components: {
            Layout,
            Theme,
            LikeComponent: LikeMindfulMoment,
            SessionsListComponent: SessionsList,
            TitleComponent: Title
        },
        data() {
            return {
                theme: ''
            };
        },
        props: {
            id: VueTypes.string.def('')
        },
        computed: {
            ...mapGetters('mindfulMinute', ['session'])
        },
        async created() {
            let randomIndex = Math.floor(
                Math.random() * i18n.t('mindfulMinutes.view.themes').length
            );
            this.theme = i18n.t('mindfulMinutes.view.themes')[randomIndex];
            this.read(this.id);
        },
        methods: {
            ...mapActions('mindfulMinute', ['read'])
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../../../assets/style/_mixins.styl";
    @import "../../../../assets/style/_variables.styl";

    .mindfulMinute
        position: relative
        height: 380px
        border-radius: 10px

    .mindfulMinuteText
    .mindfulMinuteImage
        position: absolute
        z-index: 1
        border-radius: 15px
        top: 0
        width: 55%
        height: 100%
        font-style: italic

    .mindfulMinuteText
        right: 0
        background-color: $theme.info
        padding: 15px
        width: 52.5%

        .textWrapper
            font-size: 23px
            font-weight: 300
            text-align: center
            height: 100%
            display: flex
            align-items: center
            justify-content: center

    .mindfulMinuteImage
        left: 0
        background-size: cover
        background-position: center center

    .imageAuthor
        position: absolute
        left: 15px
        bottom 15px
        opacity: 0.8
        font-size: 11px

    .bottomSpacer
        height: 80px

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .mindfulMinute
            height: 220px

        .mindfulMinuteText
            background-color: rgba($theme.info, 0.6)

        .mindfulMinuteText
        .mindfulMinuteImage
            width: 100%

        .mindfulMinuteText .textWrapper
            font-size: 16px

        .sessionsTitle
            margin-bottom: 4px

        .themeGrid
            margin: -4px !important

        .themeGrid >>> .flex
            padding: 4px !important

        .themeGrid >>> .my-2
            margin-top: 0 !important
            margin-bottom: 0 !important
</style>
